<template>
  <div class="rank-f item">
    <div class="top">
      <div class="left">
        <div class="icon"></div>
        <div class="title"><span>Ranking</span> do fórum</div>
      </div>
      <div class="actions">
        <button :disabled='prev === 0' @click="getRank(prev)"><i class="fa-solid fa-angle-left"></i></button>
        <button :disabled='next === 0' @click="getRank(next)"><i class="fa-solid fa-angle-right"></i></button>
      </div>
    </div>
    <div class="content">
      <template v-if="loading">
        <div class="box" v-for="i in 5" :key="i">
          <div class="box-avatar"><div class="avatar"></div></div>
          <div class="data flex flex-col gap-1.5 justify-center">
            <Sk w="80px" h="12px" />
            <Sk w="55px" h="10px" />
          </div>
          <Sk w="28px" h="28px" rounded="rounded-full" extra="mr-2 self-center" />
        </div>
      </template>
      <div class="box animate__animated animate__headShake" v-else v-for="(r, i) in rank" :key="i">
        <div class="box-avatar">
          <div class="avatar"
               :style="{backgroundImage: `url('${avatarUrl(r.user, { action: '', direction: 3, headonly: true, img_format: '', dance: '', effect: '', frame_num: 30 })}')`}"></div>
        </div>
        <div class="data">
          <span class="nick" @click="() => {perfilName = r.user; showP = true}">{{ r.user }}</span>
          <span>{{ r.count }} comentários</span>
        </div>
        <div class="rank" :class="{gold: r.rank === 1, silver: r.rank === 2, bronze: r.rank === 3}">{{ r.rank }}</div>
      </div>
    </div>
    <Transition name="slide-fade">
      <ItemPerfil v-if="showP" @close="showP = false" :user="perfilName" />
    </Transition>
  </div>
</template>

<script setup>
import { getRankComments, avatarUrl } from '@/services/api.js'
import ItemPerfil from '@/components/modals/perfil.vue'
import Sk from '@/components/usefulness/Sk.vue'
import { onMounted, ref } from 'vue'

let rank = ref([])
let loading = ref(true)
// let disableP = ref(false)
// let disableN = ref(false)
let showP = ref(false)
let perfilName = ref('')
let next = ref(0)
let prev = ref(0)
let total = ref(0)

async function getRank(p = 1) {
  loading.value = true
  try {
    const data = await getRankComments({ pag: p })
    rank.value  = data.comments ?? []
    prev.value  = data.prev ?? 0
    next.value  = data.next ?? 0
    total.value = data.total ?? 0
  } catch {
    rank.value = []
  } finally {
    loading.value = false
  }
}

onMounted(() => getRank())

</script>

<style scoped>

.rank-f {
  position: relative;
  width: 100%;
  @apply pt-2 pr-2;
}

.rank-f .top .icon {
  background-image: url('../../assets/icon5.png');
  background-position: 58% 45%;
  background-color: #37758D;
}

.rank-f .content {
  width: 100%;
  height: 370px;
  background-color: #fff;
  border-radius: 12px;
  padding: 4px 10px 4px 10px;
}

.rank-f .box {
  width: 100%;
  height: 68px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}

.rank-f .box .box-avatar {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  background-color: #F8FAFC;
  border-radius: 12px;
}

.rank-f .box .box-avatar .avatar {
  width: 100%;
  height: 100%;
  background-position: 50% 30%;
  background-repeat: no-repeat;
}

.rank-f .box .data {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.rank-f .box .data span {
  float: left;
  width: 100%;
  height: 20px;
  line-height: 20px;
  margin-top: 0;
  font-size: 13px;
  font-weight: 500;
  color: #949EA9;
}

.rank-f .box .data span.nick {
  font-size: 15px;
  font-weight: 600;
  color: var(--color1);
  margin-top: 0;
}

/*noinspection ALL*/
.rank-f .box .rank {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  background-color: var(--color2);
  color: #fff;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  line-height: 32px;
  user-select: none;
  margin-top: 0;
}

.rank-f .box .rank.gold {
  background-color: #F7BD15;
}

.rank-f .box .rank.silver {
  background-color: #A8A8A8;
}

.rank-f .box .rank.bronze {
  background-color: #E56841;
}
</style>
